import { whiteList } from "xss";

export default () => {
  const newWhiteList = JSON.parse(JSON.stringify(whiteList));
  newWhiteList["a"] = [
    "download",
    "href",
    "hreflang",
    "ping",
    "referrerpolicy",
    "rel",
    "target",
    "type",
    "title",
    "charset",
    "coords",
    "name",
    "rev",
    "shape",
  ];
  newWhiteList["area"] = [
    "alt",
    "coords",
    "download",
    "href",
    "ping",
    "referrerpolicy",
    "rel",
    "shape",
    "target",
  ];
  newWhiteList["button"] = [
    "autofocus",
    "disabled",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formnovalidate",
    "formtarget",
    "name",
    "popovertarget",
    "popovertargetaction",
    "type",
    "value",
  ];
  newWhiteList["caption"] = ["align"];
  newWhiteList["col"] = newWhiteList["colgroup"] = [
    "span",
    "align",
    "bgcolor",
    "char",
    "charoff",
    "valign",
    "width",
  ];
  newWhiteList["img"] = [
    "alt",
    "crossorigin",
    "decoding",
    "elementtiming",
    "fetchpriority",
    "height",
    "ismap",
    "loading",
    "longdesc",
    "referrerpolicy",
    "sizes",
    "src",
    "srcset",
    "usemap",
    "width",
    "align",
    "border",
    "hspace",
    "longdesc",
    "name",
    "vspace",
  ];
  newWhiteList["li"] = ["value"];
  newWhiteList["map"] = ["name"];
  newWhiteList["ol"] = ["reversed", "start", "type"];
  newWhiteList["style"] = [];
  newWhiteList["table"] = [
    "align",
    "bgcolor",
    "border",
    "cellpadding",
    "cellspacing",
    "frame",
    "rules",
    "summary",
    "width",
  ];
  newWhiteList["tbody"] =
    newWhiteList["tfoot"] =
    newWhiteList["thead"] =
      ["align", "bgcolor", "char", "charoff", "valign"];
  newWhiteList["td"] = newWhiteList["th"] = [
    "abbr",
    "align",
    "axis",
    "bgcolor",
    "char",
    "charoff",
    "colspan",
    "headers",
    "height",
    "nowrap",
    "rowspan",
    "scope",
    "valign",
    "width",
  ];
  newWhiteList["tr"] = ["align", "bgcolor", "char", "charoff", "valign"];
  newWhiteList["ul"] = ["compact", "type"];
  newWhiteList["video"] = [
    "autoplay",
    "controls",
    "controlslist",
    "crossorigin",
    "disablepictureinpicture",
    "disableremoteplayback",
    "height",
    "loop",
    "muted",
    "playsinline",
    "poster",
    "preload",
    "src",
    "width",
  ];

  // VML (Vector Markup Language) tags for MSO compatibility
  // Used primarily for Outlook buttons and shapes
  newWhiteList["v:roundrect"] = [
    "arcsize",
    "coordorigin",
    "coordsize",
    "fillcolor",
    "href",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:fill"] = ["color", "type"];
  newWhiteList["v:stroke"] = ["color", "weight"];
  newWhiteList["v:textbox"] = ["inset"];
  newWhiteList["v:rect"] = [
    "coordorigin",
    "coordsize",
    "fillcolor",
    "href",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:oval"] = [
    "coordorigin",
    "coordsize",
    "fillcolor",
    "href",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:shape"] = [
    "coordorigin",
    "coordsize",
    "fillcolor",
    "href",
    "path",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:line"] = [
    "from",
    "to",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:polyline"] = [
    "points",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:curve"] = [
    "from",
    "to",
    "control1",
    "control2",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:arc"] = [
    "startangle",
    "endangle",
    "strokecolor",
    "strokeweight",
    "xmlns:v",
  ];
  newWhiteList["v:group"] = ["coordorigin", "coordsize", "xmlns:v"];
  newWhiteList["v:image"] = ["src", "xmlns:v"];

  const globalAttributes = [
    "accesskey",
    "autocapitalize",
    "autofocus",
    "class",
    "contenteditable",
    "dir",
    "exportparts",
    "hidden",
    "id",
    "itemid",
    "itemprop",
    "itemref",
    "itemscope",
    "itemtype",
    "lang",
    "part",
    "role",
    "spellcheck",
    "style",
    "tabindex",
    "title",
    "translate",
  ];

  for (const key in newWhiteList) {
    newWhiteList[key] = newWhiteList[key].concat(globalAttributes);
  }
  return newWhiteList;
};
